export default __webpack_public_path__ + "static/media/i-nwr-logo-beta.d132d191.svg";